import { useToggle } from 'ahooks'
import { Modal } from 'antd'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { routes } from '@/routes'

import { ShareList } from '../share-list/share-list.component'
import { UserListFetchType, UsersList, UsersListProps } from './users-list.component'

export interface UserListModalProps extends Partial<UsersListProps> {
  title: string
  type?: UserListFetchType
}

export const UserListModal: React.FC<UserListModalProps> = ({
  children,
  title,
  fetchCount,
  showSearch,
  showIndex,
  type,
  userId,
  groupId,
  postId,
  eventId,
  paginationInput,
  extra,
  onClickUser,
  pinTop = true,
}) => {
  const history = useHistory()
  const [visible, { toggle }] = useToggle()

  children = React.cloneElement(children as any, {
    onClick: toggle,
  })

  onClickUser ||= (u: { userId: number; email: string }) => {
    toggle()
    history.push(routes.users.page(u.email))
  }

  return (
    <>
      {children}
      <Modal
        visible={visible}
        footer={null}
        title={title}
        onCancel={() => toggle()}
        destroyOnClose
        style={{ top: 20 }}
        bodyStyle={{ padding: 0 }}
      >
        {type === 'sharedUsers' && postId ? (
          <ShareList postId={postId} toggle={toggle} />
        ) : (
          <UsersList
            fetchCount={fetchCount}
            showSearch={showSearch}
            showIndex={showIndex}
            type={type}
            eventId={eventId}
            userId={userId}
            groupId={groupId}
            postId={postId}
            extra={extra ? (userId: number) => extra(userId) : undefined}
            onClickUser={onClickUser}
            paginationInput={paginationInput}
            pinTop={pinTop}
          />
        )}
      </Modal>
    </>
  )
}
